import React from 'react';

import { Typography } from '@mui/material';

import {
  AgreementContentBlockType,
  IAgreementContentBlock,
} from '../../../redux/api/agreements/interfaces';

interface IAgreementsRegularBlocksProps {
  blocks: IAgreementContentBlock[];
  keyPrefix: string;
}

const AgreementsRegularBlocks = ({
  blocks,
  keyPrefix,
}: IAgreementsRegularBlocksProps) => (
  <>
    {blocks.map((block, i) => {
      const key = `${block.type}-${keyPrefix}-${i}`;
      if (block.type === AgreementContentBlockType.TITLE) {
        return (
          <Typography key={key} variant="h3" component="h3">
            {block.value}
          </Typography>
        );
      }
      return (
        <Typography
          key={key}
          variant="body1"
          color="text.secondary"
          sx={{ whiteSpace: 'pre-wrap' }}>
          {block.value}
        </Typography>
      );
    })}
  </>
);

export default AgreementsRegularBlocks;
